import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css";
Swiper.use([Navigation, Pagination]);

// Carousel Type 1
var carouselType1Elements = document.querySelectorAll(".m-carousel.type-1");
var swiperType1Instances = [];
carouselType1Elements.forEach(function (carouselElement) {
  var swiperType1 = new Swiper(
    carouselElement.querySelector(".swiper-container"),
    {
      // loop: true,
      slidesPerView: 1.00000001,
      spaceBetween: 13 / 2,
      breakpoints: {
        380: {
          spaceBetween: 14 / 2,
        },
        480: {
          spaceBetween: 22.5 / 2,
        },
        768: {
          spaceBetween: 32 / 2,
        },
        992: {
          spaceBetween: 48 / 2,
        },
      },
      navigation: {
        nextEl: carouselElement.querySelector(".swiper-button-next"),
        prevEl: carouselElement.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: carouselElement.querySelector(".swiper-pagination"),
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            " of " +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        },
        formatFractionCurrent: function (number) {
          return number < 10 ? "0" + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? "0" + number : number;
        },
      },
    },
  );

  swiperType1Instances.push(swiperType1);
});

// Carousel Type 2
var carouselType2Elements = document.querySelectorAll(".m-carousel.type-2");
var swiperType2Instances = [];
carouselType2Elements.forEach(function (carouselElement) {
  var swiperType2 = new Swiper(
    carouselElement.querySelector(".swiper-container"),
    {
      loop: true,
      slidesPerView: 1.00000001,
      spaceBetween: 13 + 2,
      breakpoints: {
        380: {
          spaceBetween: 14 + 2,
        },
        480: {
          spaceBetween: 22.5 + 2,
        },
        768: {
          spaceBetween: 32 + 2,
        },
        992: {
          spaceBetween: 48 + 2,
        },
      },
      navigation: {
        nextEl: carouselElement.querySelector(".swiper-button-next"),
        prevEl: carouselElement.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: carouselElement.querySelector(".swiper-pagination"),
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            " of " +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        },
        formatFractionCurrent: function (number) {
          return number < 10 ? "0" + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? "0" + number : number;
        },
      },
    },
  );

  swiperType2Instances.push(swiperType2);
});

// Set height of .swiper-button-pagination-container to achieve correct layout for carousel (type-2)
export function carouselPaginationHeight() {
  const carousels = document.querySelectorAll(".m-carousel.type-2");

  if (carousels.length) {
    carousels.forEach((carousel) => {
      const imageContainer = carousel.querySelector(".image-container");
      const paginationContainer = carousel.querySelector(
        ".swiper-button-pagination-container",
      );

      if (imageContainer && paginationContainer) {
        const imageHeight = imageContainer.offsetHeight;
        paginationContainer.style.height = `${imageHeight}px`;
      }
    });
  }
}
